import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { StorageService, StorageType, TimerService } from '@rct/lynx-lobbies-shared-lib';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { LYNX_STORAGE_KEYS } from './core/constants/lynx-storage-keys.constant';
import { LynxLobbyService } from './core/services/lobby.service';
import { LynxLocalizeRouterService } from './core/services/localize-router.service';

@Injectable()
export class LobbyCheck {
  isUserAuthenticated: boolean;
  constructor(
    private localizeRouterService: LynxLocalizeRouterService,
    private storageService: StorageService,
    private lobbyService: LynxLobbyService,
    private timerService: TimerService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const { queryParams } = route;

    const normalizedParams: { [key: string]: string } = Object.keys(
      queryParams
    ).reduce((params: { [key: string]: string }, key: string) => {
      params[key.toLocaleLowerCase()] = queryParams[key];
      return params;
    }, {});

    if (normalizedParams.lobbyid) {
      this.storageService.set(
        LYNX_STORAGE_KEYS.lobbyId,
        normalizedParams.lobbyid,
        { type: StorageType.Session }
      );
    }

    const lobbyId = this.storageService.get(
      LYNX_STORAGE_KEYS.lobbyId,
      StorageType.Session
    );

    let activatedRouteUrl: string = this.getActivatedRouteUrl(route);

    if (activatedRouteUrl.includes('/:locale/')) {
      activatedRouteUrl = activatedRouteUrl.replace('/:locale/', '');
    }

    if (activatedRouteUrl.charAt(0) === '/') {
      activatedRouteUrl = activatedRouteUrl.substring(1);
    }

    if (lobbyId) {
      return this.lobbyService
        .getLobbyDetails$(activatedRouteUrl, () => {
          this.lobbyService.updateDefaultLanguageLoadStatus(true);
          this.localizeRouterService.translateRoute('404', true);
        })
        .pipe(
          take(1),
          map(() => true)
        );
    }
    this.timerService.stopAll();
    this.storageService.lynxClearExceptLobbyAndLocale(LYNX_STORAGE_KEYS);
    this.localizeRouterService.translateRoute('404', true);

    return of(!!lobbyId);
  }

  private getActivatedRouteUrl(route: ActivatedRouteSnapshot): string {
    return (
      '/' +
      route.pathFromRoot
        .filter((path) => path.routeConfig)
        .map((path) => path.routeConfig.path)
        .join('/')
    );
  }
}
